import { render, staticRenderFns } from "./GiftCardConfirmationModal.vue?vue&type=template&id=12939652&scoped=true&"
import script from "./GiftCardConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./GiftCardConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardConfirmationModal.vue?vue&type=style&index=0&id=12939652&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12939652",
  null
  
)

export default component.exports